'use client'

import styled from "styled-components";
import {getColor} from "@/pipes/theme.pipe";
import Modal from "@/components/UI/Containers/Modal/Modal";
import Button from "@/components/UI/Button/Button";
import Description from "@/components/UI/Description/Description";
import Title from "@/components/UI/Title/Title";

export const ConfirmEmail = styled(Modal)`
    //background: ${getColor('secondary', '700')};
    
    .ant-modal-content {
        padding: 40px 70px;
    }
    
    .ant-modal-body {
        display: flex;
        flex-direction: column;
        gap: 40px;
        align-items: center;
    }
`

export const ConfirmEmailTitleDescWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 27px;
    width: 100%;
`

export const ConfirmEmailTitle = styled(Title).attrs({
    size: 'sm'
})`
    font-size: 24px;
`

export const ConfirmEmailDescription = styled(Description).attrs({
    size: 'sm'
})`
    font-weight: 300
`

export const ConfirmEmailButton = styled(Button).attrs({
    size: 'md',
})`
    font-size: 14px;
    padding: 15px 40px;
    letter-spacing: 1px;
    margin: 30px auto !important;
`

export const ReceiveLinkButton = styled(Button).attrs({
    variant: 'link',
    href: '/'
})`
    text-decoration: underline;
    color: ${getColor('primary', '500')} !important;
    font-size: 14px;
`